<template>
  <li
    v-if="upload.levelFields[1]"
    :class="{ bold: upload.levelFields[1].showBubbles }"
  >
    {{ level1 }}
    <HierarchyItemChildren
      :level1="level1"
      :props="items"
    />
  </li>
</template>

<script lang="ts">
import { useUploadStore } from '@/store/admin/upload'
import HierarchyItemChildren from '@/components/admin/upload/CSVSettings/DefineHierarchy/HierarchyItemChildren.vue'
import Vue from 'vue'
import Component from 'vue-class-component'

const props = {
  level1: {
    type: String,
    required: true,
  },
}

@Component({ components: { HierarchyItemChildren } })
export default class HierarchyItem extends Vue.extend({ props }) {
  upload = useUploadStore()

  get items () {
    const getLevelItems = (level: number):any => level > this.upload.levelCount ? undefined : ({
      level1: this.level1,
      field: this.upload.levelsHelper.fieldForLevel(level),
      items: this.upload.level1Descendants(this.level1, level),
      child: getLevelItems(level + 1),
    })

    return getLevelItems(2)
  }
}

</script>

<style scoped>
.bold {
  font-weight: bold;
}
li {
  font-weight: normal;
}
</style>
